export default __webpack_public_path__ + "static/media/cloudy.5cd1258e.svg";